import { NgModule, APP_INITIALIZER } from '@angular/core';
/* ngTransalte Module*/
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
/* Routing Module*/
import { AppRoutingModule } from './app-routing.module';
/* Providers */
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomTranslateLoader } from './shared/utils/custom-translate-loader.component';
import { environment } from '../environments/environment';
import { CoreConfigurationsLoaderService, CoreConfigurationsLoaderModule } from '@vfde-fe/ngx-lib/services/core-configurations-loader';
import { ConfigLoaderService } from './shared/services/config-loader.service';
import { APP_PROVIDERS } from './app.providers';
// ng-rx imports
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers, metaReducers } from './redux/reducers';
import { RoutingEffect } from './redux/effects/routing.effect';
import { OverlayEffect } from './redux/effects/overlay.effect';
import { DisableDeepLinksGuard } from './shared/authentication/disable-deeplinks.guard';
import { AuthService } from './common/authentication/auth.service';
import { CoreAuthenticationService, CoreAuthenticationModule } from '@vfde-fe/ngx-lib/services/core-authentication';
import { CustomerSupportEffect } from './redux/effects/customer-support.effects';
import { HTTPClientInterceptor } from './shared/services/interceptors/http-client-interceptor.service';
import {APP_BASE_HREF} from '@angular/common';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

/** createTranslateLoader */
export function createTranslateLoader (http: HttpClient, configLoaderService: ConfigLoaderService) {
    return new CustomTranslateLoader(http, configLoaderService, environment.configPath + 'i18n/', '.json');
}
/** configLoaderFactory */
export function configLoaderFactory (config: ConfigLoaderService) {
    return () => config.load();
}
/** AppModule */
@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        CoreAuthenticationModule.forRoot({
            provide: CoreAuthenticationService,
            useClass: AuthService,
        }),
        CoreConfigurationsLoaderModule.forRoot({
            provide: CoreConfigurationsLoaderService,
            useClass: ConfigLoaderService,
        }),
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        HttpClientModule,
        AppRoutingModule,
        NgxPageScrollCoreModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient, CoreConfigurationsLoaderService],
            },
        }),

        StoreModule.forRoot(reducers, { metaReducers }),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        EffectsModule.forRoot([RoutingEffect, CustomerSupportEffect, OverlayEffect]),
    ],
    providers: [
        { provide: APP_BASE_HREF, useValue: '/retoure' },
        DisableDeepLinksGuard,
        APP_PROVIDERS,
        {
            provide: APP_INITIALIZER,
            useFactory: configLoaderFactory,
            deps: [CoreConfigurationsLoaderService],
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: HTTPClientInterceptor, multi: true},
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
